import React from 'react'

const RingGreenIcon = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="24" fill="#ECF7F0"/>
        <path d="M23.999 34C29.5219 34 33.999 29.5228 33.999 24C33.999 18.4772 29.5219 14 23.999 14C18.4762 14 13.999 18.4772 13.999 24C13.999 29.5228 18.4762 34 23.999 34Z" stroke="#43B46C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M24 30C27.3137 30 30 27.3137 30 24C30 20.6863 27.3137 18 24 18C20.6863 18 18 20.6863 18 24C18 27.3137 20.6863 30 24 30Z" stroke="#43B46C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M24.001 26C25.1055 26 26.001 25.1046 26.001 24C26.001 22.8954 25.1055 22 24.001 22C22.8964 22 22.001 22.8954 22.001 24C22.001 25.1046 22.8964 26 24.001 26Z" stroke="#43B46C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  )
}

export default RingGreenIcon